import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    public canActivate(): boolean {

        const result: boolean = this.authService.isAuthenticated();

        if (!result) {

            this.router.navigate(['/login']);
        }

        return result;
    }
}
